import { useEffect, useState } from 'react';
import { UTMInfoKeysEnum } from '@entities/current-user/api/credentials-user-types';
import { useLocation } from 'react-router-dom';

export const useCurrentUserUtm = () => {
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const [utmInfo, setUTMInfo] = useState<Partial<Record<UTMInfoKeysEnum, string>> | null>(null);

    useEffect(() => {
        let currentUTMs: Partial<Record<UTMInfoKeysEnum, string>> | null = null;

        for (const utmKey of Object.values(UTMInfoKeysEnum)) {
            const value = searchParams.get(utmKey) || localStorage.getItem(utmKey);

            if (value) {
                if (!currentUTMs) {
                    currentUTMs = {};
                }
                currentUTMs[utmKey] = value;
                searchParams.delete(utmKey);
                localStorage.removeItem(utmKey);
            }
        }

        setUTMInfo(currentUTMs);
    }, []);

    return utmInfo;
};
